import React from 'react';
import PropTypes from 'prop-types';
import SerialDilution from './SerialDilution';

function SerialDilutionWizardView({show, selectedCard}) {
  return show ? (
    <div className="protocol-editor__div__content-wizard">
      <SerialDilution cardID={selectedCard?.ID} />
    </div>
  ) : null;
}

SerialDilutionWizardView.propTypes = {
  show: PropTypes.bool,
  selectedCard: PropTypes.object,
};

SerialDilutionWizardView.defaultProps = {
  show: false,
  selectedCard: {},
};

export default SerialDilutionWizardView;
